import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';

import CollapsablePanel from 'Common/Components/controlled-collapsable-panel/ControlledCollapsablePanel';
import ActionButton from 'Common/Buttons/ActionButton';
import SuccessFailure from 'Common/Components/success-failure/SuccessFailure.container';
import styles from './updater.module.css';

import UpdateRow from './UpdateRow/UpdateRow.view';
import ConfirmCancel from 'Common/Components/ConfirmModal/ConfirmModal';

const UpdaterView = ({
    open,
    disabled,
    isSelecting,
    inPreview,
    saveInvoked,
    updatedAll,
    showModal,
    selectedUpdater,
    savedAll,
    savedSome,
    showAddIcon,
    showCancelButton,
    showPreviewButton,
    showSaveButton,
    showRemovePreviewButton,

    updateOptions,
    updates,

    togglePanel,
    handleAddSelector,
    handleRemoveSelector,
    handleAddUpdater,
    handleFieldChange,
    handleRemoveUpdater,
    handlePreview,
    handleRemovePreview,
    handleSave,
    handleCancel,
    handleCancelWithdrawn,
    handleCancelConfirmed,
    handleStartNew,
    handleViewSaved,
    handleViewFailed,
    handleViewRefined,
    successMessage,
    failMessage,
    year
}) => {
    return (
            <CollapsablePanel open={open} disabled={disabled} onClick={togglePanel}>
                <CollapsablePanel.Closed>
                    <div className={styles['updater-closed']}>
                        <Typography variant="h3">Group Update</Typography>
                    </div>
                </CollapsablePanel.Closed>

                <CollapsablePanel.Open>
                    <div className={styles['updater-open']}>
                        <div className={styles.heading}>
                            <div className={styles['heading-item']}>
                                <Typography variant="h3">Group Update</Typography>
                            </div>
                            <div className={styles['heading-item']}>
                                {showAddIcon && <AddIcon style={{ fontSize: 32 }} onClick={handleAddSelector} tabIndex="0" onKeyPress={handleAddSelector} />}
                                {isSelecting && <RemoveIcon style={{ fontSize: 32 }} onClick={handleRemoveSelector} tabIndex="0" onKeyPress={handleRemoveSelector} />}
                            </div>
                            <div className={styles['heading-selector']}>
                                {isSelecting && (
                                    <Select value={selectedUpdater} onChange={handleAddUpdater} displayEmpty>
                                        <MenuItem key="Initial" value="" style={{width: '20em'}}>
                                            Select
                                        </MenuItem>
                                        {updateOptions.map(option => (
                                            <MenuItem key={option} value={option}>
                                                {option}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            </div>
                            <div className={styles['save-result']}>
                                <SuccessFailure hasResult={saveInvoked} result={updatedAll} successMessage={successMessage} failMessage={failMessage} />
                                {savedSome && <div className={styles['result-buttons']}>
                                    <Button size="small" className={styles['view-saved']} onClick={handleViewSaved}>Saved</Button>
                                    <Button size="small" className={styles['view-failed']} onClick={handleViewFailed}>Failed</Button>
                                    <Button size="small" className={styles['view-refined']} onClick={handleViewRefined}>Refined</Button>
                                </div>}
                            </div>
                        </div>

                        {updates.map(update => (
                            <UpdateRow
                                key={update.field}
                                field={update.field}
                                value={update.value}
                                onChange={handleFieldChange(update.field)}
                                onRemove={handleRemoveUpdater(update.field)}
                                isSavedOrPreview={updatedAll || inPreview}
                                year={year}
                            />
                        ))}
                        <div className={styles.buttons}>
                            {showCancelButton && <ActionButton text="Cancel" onClick={handleCancel} containerClass={styles['cancel-button']} />}
                            {showPreviewButton && <ActionButton text="Preview" onClick={handlePreview} containerClass={styles['preview-button']} />}
                            {showRemovePreviewButton && <ActionButton text="Remove Preview" onClick={handleRemovePreview} containerClass={styles['preview-button']} />}
                            {showSaveButton && <ActionButton text="Save" onClick={handleSave} containerClass={styles['save-button']} />}
                            {savedAll && <ActionButton text="Start New Update" onClick={handleStartNew} containerClass={styles['new-update-button']} />}
                        </div>
                        <ConfirmCancel
                            isOpen={showModal}
                            heading={'Cancel Group Update'}
                            message={'If you cancel now, all your updates will be lost. Do you wish to proceed and cancel your updates?'}
                            onProceed={handleCancelConfirmed}
                            onWithdraw={handleCancelWithdrawn}
                        />
                    </div>
                </CollapsablePanel.Open>
            </CollapsablePanel>
    );
};

UpdaterView.propTypes = {
    open: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    isSelecting: PropTypes.bool.isRequired,
    inPreview: PropTypes.bool.isRequired,
    saveInvoked: PropTypes.bool.isRequired,
    updatedAll: PropTypes.bool,
    showModal: PropTypes.bool.isRequired,

    savedAll: PropTypes.bool.isRequired,
    savedSome: PropTypes.bool.isRequired,
    showAddIcon: PropTypes.bool.isRequired,
    showCancelButton: PropTypes.bool.isRequired,
    showPreviewButton: PropTypes.bool.isRequired,
    showSaveButton: PropTypes.bool.isRequired,
    showRemovePreviewButton: PropTypes.bool.isRequired,

    selectedUpdater: PropTypes.string.isRequired,
    updateOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
    updates: PropTypes.arrayOf(PropTypes.object).isRequired,

    togglePanel: PropTypes.func.isRequired,
    handleAddSelector: PropTypes.func.isRequired,
    handleRemoveSelector: PropTypes.func.isRequired,
    handleAddUpdater: PropTypes.func.isRequired,
    handleFieldChange: PropTypes.func.isRequired,
    handleRemoveUpdater: PropTypes.func.isRequired,
    handlePreview: PropTypes.func.isRequired,
    handleRemovePreview: PropTypes.func.isRequired,

    handleSave: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleCancelWithdrawn: PropTypes.func.isRequired,
    handleCancelConfirmed: PropTypes.func.isRequired,
    handleStartNew: PropTypes.func.isRequired,
    handleViewSaved: PropTypes.func.isRequired,
    handleViewFailed: PropTypes.func.isRequired,
    handleViewRefined: PropTypes.func.isRequired,
    successMessage: PropTypes.string.isRequired,
    failMessage: PropTypes.string.isRequired,
    year: PropTypes.string
};

export default UpdaterView;
